/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum Locale {
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Id = 'id',
  Pt = 'pt',
  Vi = 'vi',
}

/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum LocalesLanguagesConstants {
  en = 'English',
  es = 'Spanish',
  fr = 'French',
  pt = 'Portuguese',
  vi = 'Vietnamese',
  id = 'Indonesian',
}

export function getLanguageKey(language: LocalesLanguagesConstants) {
  return Object.keys(LocalesLanguagesConstants).find(
    (key) =>
      LocalesLanguagesConstants[
        key as keyof typeof LocalesLanguagesConstants
      ] === language
  );
}

enum SignInLocalMapping {
  pt = 'pt-PT',
}

export function transformLocale(inputLocale?: string): string {
  return (
    SignInLocalMapping[inputLocale as keyof typeof SignInLocalMapping] ||
    inputLocale
  );
}

export const persistLocaleCookie = (locale: string, currentLocale: string) => {
  if (locale !== currentLocale) {
    const date = new Date();
    const expireMs = 100 * 24 * 60 * 60 * 1000; // 100 days
    date.setTime(date.getTime() + expireMs);
    document.cookie = `NEXT_LOCALE=${locale};expires=${date.toUTCString()};path=/`;
  }
};
